//import { Component, OnInit } from '@angular/core';
import { Component, Input, EventEmitter, Output, OnChanges, OnInit } from '@angular/core';

@Component({
  selector: 'app-account-header',
  templateUrl: './account-header.component.html',
  styleUrls: ['./account-header.component.css']
})
export class AccountHeaderComponent implements OnInit {

  showfilter : boolean = false;
  show_class = '';
  package_status_ary:any;
  @Output() emit1 = new EventEmitter();
  @Output() emit2 = new EventEmitter();
  
  search_key = '';
  constructor() { }

  ngOnInit() {
  }

  update_package_status(package_status_ary){
    this.package_status_ary = package_status_ary;
  }

  applyFilter(){
    console.log('applyFilter');
    this.show_class = '';
    this.emit1.emit(this.search_key);
  }

  resetFilter(){
    console.log('resetFilter');
    this.show_class = '';
    this.search_key = '';
    this.emit2.emit(this.search_key);
  }

  showFilterButton(val:boolean) {
    this.showfilter = val;
    if (this.showfilter) {
      //this.show_class = 'show';
    } else {
      this.show_class = '';
    }
  }

  showFilterBox() {
    if(this.show_class=='show'){
      this.show_class = '';
    } else {
      this.show_class = 'show';
    }
  }

  

}



// WEBPACK FOOTER //
// ./src/app/account-header/account-header.component.ts